module.exports = __webpack_public_path__ + "static/img/home_poster.01ce85c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/home_poster.jpg
// module id = A8Nn
// module chunks = 1